// src/components/NavBar.js
import React, { useState, useCallback } from "react";
import { Link, useNavigate } from "react-router-dom";
import { getAuth, signOut } from "firebase/auth";
import { firebaseApp } from "../../firebase/firebaseApp";
import { useAuth } from "../../context/AuthContext";

function NavBar({ className = "" }) {
  const [menuOpen, setMenuOpen] = useState(false);
  const navigate = useNavigate();

  // Get claims to check role
  const { user, claims } = useAuth();
  const role = claims?.role;
  const showAdmin =
    ["monitor", "principal_investigator", "chief_investigator"].includes(
      role,
    ) || user?.email == "bdruce@electronrx.com";

  const handleSignOut = useCallback(() => {
    signOut(getAuth(firebaseApp))
      .then(() => navigate("/auth/login", { replace: true }))
      .catch((err) => console.error(err));
  }, [navigate]);

  const handleNavigate = useCallback(() => setMenuOpen(false), []);

  return (
    <header
      className={`flex items-center justify-between w-full p-2 md:gap-4 z-50 ${className}`}
    >
      {/* Logo */}
      <Link to="/home" aria-label="PDX Home" onClick={handleNavigate}>
        <img
          src="/pdx_logo.png"
          alt="PDX logo"
          className="h-12 w-auto"
          loading="lazy"
        />
      </Link>

      <div className="flex flex-row gap-4 items-center justify-center">
        <Link to="/videos">Recording Viewer</Link>

        {/* Condition Admin Link */}
        {showAdmin && <Link to="/admin">Admin</Link>}

        <button
          type="button"
          onClick={handleSignOut}
          className="focus:outline-none "
        >
          Signout
        </button>
      </div>
      <img
        src="/2021electronRx Logo- Blue@4x.png"
        alt="electronRx logo"
        className="h-12 w-auto"
        loading="lazy"
      />
    </header>
  );
}

export default React.memo(NavBar);
